import { fetchBaseQuery, BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

export function createAuthBaseQuery(baseUrl: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  const rawBase = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });

  return async (args, api, extraOptions) => {
    const result = await rawBase(args, api, extraOptions);
    if (result.error) {
      const status = result.error.status;
      if (status === 502 || status === 503 || status === 504) {
        return {
          error: {
            status,
            data: 'Servidor temporariamente indisponível. Tente novamente em instantes.',
          } as FetchBaseQueryError,
        };
      }
    }
    return result;
  };
}
